'use client';

import Issue from "@/src/_types/issue";
import {Post} from "@/src/_types/Post/post";
import {Box, Divider, Typography} from "@mui/material";
import PostItem from "@/src/components/main-site/posts/post-item/post-item";
import useSWR from "swr";
import {fetcher} from "@/src/utils/fetch-helpers";
import Journal from "@/src/_types/journal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars} from "@fortawesome/pro-duotone-svg-icons";
import Loading from "@/src/components/common/loading/loading";

const IssueContent = (
    {
        initialJournalData,
        initialIssueData,
        initialPostsIssueData,
        journalTitle,
        issueId,
    }: {
        initialJournalData: Journal;
        initialIssueData: Issue;
        initialPostsIssueData: Post[];
        journalTitle: string;
        issueId: number;
    }
) => {
    const {
        data: journalResponse,
        isLoading: isJournalLoading
    } = useSWR(
        `/api/journals?path=${journalTitle}`,
        fetcher,
        {
            fallbackData: {success: true, data: [initialJournalData]},
            revalidateOnMount: false,
            revalidateOnFocus: false,
            revalidateIfStale: false,
            revalidateOnReconnect: false,
        }
    );

    const journal = Array.isArray(journalResponse?.data) ? journalResponse.data[0] : journalResponse?.data;

    const {
        data: issueResponse,
        isLoading: isIssueLoading
    } = useSWR(
        `/api/issues?id=${issueId}&journalId=${journal?.id}&isMainSite=true`,
        fetcher,
        {
            fallbackData: {success: true, data: initialIssueData},
            revalidateOnMount: false,
            revalidateOnFocus: false,
            revalidateIfStale: false,
            revalidateOnReconnect: false,
        }
    );
    const issue = Array.isArray(issueResponse?.data) ? issueResponse.data[0] : issueResponse?.data;

    const {
        data: postsResponse,
        isLoading: isPostLoading
    } = useSWR(
        `/api/posts?issueId=${issue.id}&journalId=${journal?.id}&isMainSite=true`,
        fetcher,
        {
            fallbackData: {success: true, data: initialPostsIssueData},
            revalidateOnMount: false,
            revalidateOnFocus: false,
            revalidateIfStale: false,
            revalidateOnReconnect: false,
        }
    );
    const posts = postsResponse?.data ?? [];

    if (isJournalLoading || isPostLoading || isIssueLoading) {
        return (
            <Loading/>
        );
    }

    return (
        <Box py={2}>
            <Typography
                component="h1"
                fontSize={'2rem'}
            >
                {issue.name}
            </Typography>
            <Box
                display="flex"
                alignItems="center"
            >
                <Typography
                    color="primary.main"
                    fontSize={'1.25rem'}
                    mr={.25}
                >
                    <FontAwesomeIcon
                        icon={faBars}
                    />
                </Typography>
                <Typography
                    color="primary.main"
                    component="h2"
                    fontSize={'1.5rem'}
                >
                    List of Posts
                </Typography>
            </Box>
            <Divider
                sx={{
                    mt: .25,
                    mb: 2,
                    opacity: .5,
                    borderColor: 'custom.dividerBorderColor'
                }}
            />
            {
                posts?.map((post: Post) => (
                    <PostItem
                        key={`post-${post.id}`}
                        post={post}
                        journalUrl={journal?.is_main_site ? '' : journal.journal_url + '/'}
                    />
                ))
            }
        </Box>
    );
};

export default IssueContent;
